export const url = ['/fahrzeugtechnik', '/autohandel', '/autovermietung', '/taxi', '/erdbau', '/über-uns',];



// WEBPACK FOOTER //
// ./src/components/reusable/nav/url.js